"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.pagination.pagnation_info': '显示第 {startItem} 至 {endItem} 条，共 {totalItems} 条',
};
